import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { getAccTag } from "../../../store/accTag/action";
import { getPaymentMethod as onGetPaymentMethods, addNewPaymentMethod as onAddNewPaymentMethod, updatePaymentMethod as onUpdatePaymentMethod, deletePaymentMethod as onDeletePaymentMethod, getPaymentMethodLoading, resetPaymentMethodState } from "../../../store/paymentMethod/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";

const PaymentMethod = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [pageIdx, setPageIdx] = useState(0);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, paymentMethods, isPaymentMethodCreated, isPaymentMethodSuccess, loading, error, accAccounts, accAccountLoading, clients, clientLoading, companies, companyLoading, budgets, budgetLoading, branches, branchLoading, accTags, accTagLoading, } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    paymentMethods: state.PaymentMethod.paymentMethods,
    isPaymentMethodCreated: state.PaymentMethod.isPaymentMethodCreated,
    isPaymentMethodSuccess: state.PaymentMethod.isPaymentMethodSuccess,
    loading: state.PaymentMethod.loading,
    error: state.PaymentMethod.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
    budgets: state.Budget.budgets,
    budgetLoading: state.Budget.loading,
    accTags: state.AccTag.accTags,
    accTagLoading: state.AccTag.loading,
  }));

  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [paymentMethodDoc, setPaymentMethodDoc] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [budgetList, setBudgetList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [tagList, setTagList] = useState([]);

  const typeData = [
    {
      options: [
        { label: "Sales", value: "Sales" },
        { label: "Purchase", value: "Purchase" },
        // { label: "Finance", value: "Finance" },
        { label: "Operational", value: "Operational" },
      ],
    },
  ];

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [accountingList, setAccountingList] = useState([]);

  const onClickDelete = (paymentMethod) => {
    setPaymentMethod(paymentMethod);
    setDeleteModal(true);
  };

  const handleDeletePaymentMethod = () => {
    if (paymentMethod) {
      dispatch(onDeletePaymentMethod(paymentMethod));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      let filteredPaymentMethods = paymentMethods;
      if (activeTypeTab !== "all") {
        filteredPaymentMethods = paymentMethods.filter((paymentMethod) => paymentMethod.pm_status?.name === activeTypeTab);
      }
      setPaymentMethodList(filteredPaymentMethods.map((el) => ({ ...el, isChecked: false })));
    } else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Tipe",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "pm_acc_account",
        label: "Akun Debit",
        isSelected: true,
        data: [],
      },
      {
        id: "pm_accto_account",
        label: "Akun Kredit",
        isSelected: true,
        data: [],
      },
      {
        id: "pm_branch",
        label: "Cabang",
        isSelected: true,
        data: [],
      },
      {
        id: "pm_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "pm_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (paymentMethodList.length > 0) {
      paymentMethodList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "pm_client" || doc.id === "pm_branch" || doc.id === "pm_company" || doc.id === "pm_acc_account" || doc.id === "pm_accto_account") {
                doc.data.push(value?.name ?? null);
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPaymentMethodDoc(dataDoc);
  }, [paymentMethodList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredPaymentMethods = paymentMethods;
      if (type !== "all") {
        filteredPaymentMethods = paymentMethods.filter((paymentMethod) => paymentMethod.pm_status?.name === type);
      }
      setPaymentMethodList(filteredPaymentMethods);
    }
  };

  useEffect(() => {
    dispatch(resetPaymentMethodState());
    dispatch(onGetPaymentMethods({ companyId: companySelected?.value, type: "all" })); //branchId: branchSelected?.value,
    handleGetAccAccount(companySelected?.value);
    handleGetBudget(companySelected?.value);
    handleGetTag(companySelected?.value);
  }, [companySelected]);

  const handleGetTag = (companyId) => {
    dispatch(getAccTag({ companyId: companyId, status: 2 }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, simple: true }));
  };

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [{ label: "NON CABANG", value: null, companyId: companySelected.value }];
      branches.sort((a, b) => (a.name ?? null).localeCompare(b.name ?? null, undefined, { numeric: true, sensitivity: "base" })).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(accTags)) {
      var data = [];
      var opt = [{ label: "NON TAG", value: "" }];
      accTags.sort((a, b) => (a.name ?? null).localeCompare(b.name ?? null, undefined, { numeric: true, sensitivity: "base" })).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setTagList(data);
    }
  }, [accTags]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPaymentMethod(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handlePaymentMethodClick = useCallback(
    (arg, edit) => {
      const paymentMethod = arg;

      setPaymentMethod({
        id: paymentMethod.id,
        name: paymentMethod.name,
        sales: paymentMethod.sales,
        isCash: paymentMethod.isCash,
        isBooked: paymentMethod.isBooked,
        description: paymentMethod.description,
        sort_order: paymentMethod.sort_order,
        type: paymentMethod.type && { label: paymentMethod.type, value: paymentMethod.type },
        tag: paymentMethod.pm_tag && { label: paymentMethod.pm_tag.name, value: paymentMethod.pm_tag.id },
        cashflow: paymentMethod.pm_budget && { label: paymentMethod.pm_budget.name + ", " + paymentMethod.pm_budget?.budget_branch?.branch_code, value: paymentMethod.pm_budget.id },
        account: paymentMethod.pm_acc_account && {
          label: paymentMethod.pm_acc_account.name,
          value: paymentMethod.pm_acc_account.id,
        },
        accountTo: paymentMethod.pm_accto_account && {
          label: paymentMethod.pm_accto_account.name,
          value: paymentMethod.pm_accto_account.id,
        },
        accountPayable: paymentMethod.pm_payable_account && {
          label: paymentMethod.pm_payable_account.name,
          value: paymentMethod.pm_payable_account.id,
        },
        company: paymentMethod.pm_company && {
          label: paymentMethod.pm_company.name,
          value: paymentMethod.pm_company.id,
        },
        branch: paymentMethod.pm_branch && {
          label: paymentMethod.pm_branch.name,
          value: paymentMethod.pm_branch.id,
        },
        client: paymentMethod.pm_client && {
          label: paymentMethod.pm_client.name,
          value: paymentMethod.pm_client.id,
        },
      });

      setIsEdit(edit);
      toggle();
    },
    [toggle, userType],
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      type: (paymentMethod && paymentMethod.type) ?? null,
      isCash: (paymentMethod && paymentMethod.isCash) || false,
      isBooked: (paymentMethod && paymentMethod.isBooked) || false,
      sort_order: (paymentMethod && paymentMethod.sort_order) || 0,
      cashflow: (paymentMethod && paymentMethod.cashflow) || 0,
      account: (paymentMethod && paymentMethod.account) ?? null,
      accountTo: (paymentMethod && paymentMethod.accountTo) ?? null,
      accountPayable: (paymentMethod && paymentMethod.accountPayable) ?? null,
      name: (paymentMethod && paymentMethod.name) ?? null,
      sales: (paymentMethod && paymentMethod.sales) ?? null,
      description: (paymentMethod && paymentMethod.description) ?? null,
      client: (paymentMethod && paymentMethod.client) || clientSelected,
      company: (paymentMethod && paymentMethod.company) || companySelected,
      branch: (paymentMethod && paymentMethod.branch) || branchSelected,
      tag: (paymentMethod && paymentMethod.tag) ?? null,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Input nama metode bayar"),
      // account: Yup.object().required("Pilih akun pembayaran").nullable(true),
      // accountTo: Yup.object().required("Pilih akun lawan pembayaran ").nullable(true),
      client: Yup.object().required("Pilih grup usaha").nullable(true),
      company: Yup.object().required("Pilih perusahaan").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getPaymentMethodLoading());
      if (isEdit) {
        const updatePaymentMethod = {
          id: paymentMethod ? paymentMethod.id : 0,
          name: values.name,
          sales: values.sales,
          type: values?.type?.value ?? null,
          isCash: values.isCash,
          isBooked: values.isBooked,
          sort_order: values.sort_order,
          description: values.description,
          accId: values?.account?.value ?? null,
          accToId: values?.accountTo?.value ?? null,
          accPayableId: values?.accountPayable?.value ?? null,
          companyId: values.company.value,
          branchId: values?.branch?.value ?? null,
          clientId: values.client.value,
          budgetId: values?.cashflow?.value ?? null,
          tagId: values?.tag?.value ?? null,
        };
        dispatch(onUpdatePaymentMethod(updatePaymentMethod));
        validation.resetForm();
      } else {
        const newPaymentMethod = {
          name: values.name,
          sales: values.sales,
          type: values?.type?.value ?? null,
          isCash: values.isCash,
          isBooked: values.isBooked,
          sort_order: values.sort_order,
          description: values.description,
          accId: values?.account?.value ?? null,
          accToId: values?.accountTo?.value ?? null,
          accPayableId: values?.accountPayable?.value ?? null,
          companyId: values.company.value,
          branchId: values?.branch?.value ?? null,
          clientId: values.client.value,
          budgetId: values?.cashflow?.value ?? null,
          tagId: values?.tag?.value ?? null,
        };
        dispatch(onAddNewPaymentMethod(newPaymentMethod));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePaymentMethod(element.value));
    });
    checkall.checked = false;
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = paymentMethodList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setPaymentMethodList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = paymentMethodList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setPaymentMethodList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("createPaymentMethod") !== -1 ? "btn-sm" : "d-none"}
                    onClick={() => {
                      handlePaymentMethodClick(data, false);
                    }}
                  >
                    <i className="ri-file-copy-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updatePaymentMethod") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handlePaymentMethodClick(data, true);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  {data.type !== "Finance" && <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deletePaymentMethod") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>}

                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          let status;
          switch (data?.pm_status?.name) {
            case "DRAFT":
              status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.pm_status?.name} </span>;
              break;
            case "ACTIVE":
              status = <span className="badge fs-10 text-uppercase badge-soft-info"> {data?.pm_status?.name} </span>;
              break;
            case "INACTIVE":
              status = <span className="badge fs-10 text-uppercase badge-soft-danger"> {data?.pm_status?.name} </span>;
              break;
            default:
              status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.pm_status?.name} </span>;
              break;
          }

          let type;
          switch (data?.description) {
            case "CASH IN":
              type = <span className="badge fs-10 text-uppercase badge-soft-success">{data?.description}</span>;
              break;
            case "CASH OUT":
              type = <span className="badge fs-10 text-uppercase badge-soft-warning">{data?.description}</span>;
              break;
            case "RECEIVABLE":
              type = <span className="badge fs-10 text-uppercase badge-soft-info">{data?.description}</span>;
              break;
            case "PAYABLE":
              type = <span className="badge fs-10 text-uppercase badge-soft-danger">{data?.description}</span>;
              break;
            default:
              type = <span className="badge fs-10 text-uppercase badge-soft-primary">{data?.description}</span>;
              break;
          }
          //const cash = data.isCash ? <span className="badge text-uppercase badge-soft-info">YES</span> : <span className="badge text-uppercase badge-soft-warning">NO </span>;
          return (
            <div>
              <p className="fw-semibold mb-0">{cell.value}</p>
              <p>
                <span className="badge fs-10 text-uppercase badge-soft-primary">{data.type === "Finance" ? "FINANCE MPD" : data.type}</span> {status} {type} <span className="badge fs-10 text-uppercase badge-soft-success">{data?.pm_tag?.name}</span>
              </p>
            </div>
          );
        },
      },
      {
        id: "Tipe",
        Header: "Tipe",
        accessor: "type",
        filterable: true,
      },
      {
        id: "Urutan",
        Header: "Urutan",
        accessor: "sort_order",
        filterable: true,
      },
      {
        id: "Tag",
        Header: "tag",
        accessor: (data) => data?.pm_tag?.name ? data?.pm_tag?.name : "NON TAG",
        filterable: true,
      },
      {
        Header: "Akun Debit",
        accessor: (data) => data?.pm_acc_account?.name ? data?.pm_acc_account?.name + " - " + data?.pm_acc_account?.acc_account_company?.code : "",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          return (
            <span>
              {data.pm_acc_account && data.pm_acc_account.code} - {data.pm_acc_account && data.pm_acc_account.name} {data.pm_acc_account?.acc_account_company && <span className="badge text-uppercase fs-11 badge-soft-info">{data.pm_acc_account?.acc_account_company?.code}</span>}
            </span>
          );
        },
      },
      {
        Header: "Akun Kredit",
        accessor: (data) => data?.pm_accto_account?.name ? data?.pm_accto_account?.name + " - " + data?.pm_accto_account?.acc_account_company?.code : "",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          return (
            <span>
              {data.pm_accto_account && data.pm_accto_account.code} - {data.pm_accto_account && data.pm_accto_account.name} {data.pm_accto_account?.acc_account_company && <span className="badge text-uppercase fs-11 badge-soft-info">{data.pm_accto_account?.acc_account_company?.code}</span>}
            </span>
          );
        },
      },
      {
        id: "Cashflow",
        Header: "Cashflow",
        accessor: (data) => data.pm_budget ? data?.pm_budget?.name + ", " + data?.pm_budget?.budget_branch?.branch_code : "-",
        filterable: true,
      },
      {
        Header: "Cabang",
        accessor: "pm_branch.name",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          return (
            <div>
              <div>{data?.pm_branch?.name}</div>
              <div>{data?.pm_company?.name}</div>
            </div>
          );
        },
      },
      {
        id: "Perusahaan",
        Header: "Perusahaan",
        accessor: (data) => data?.pm_company?.name ? data?.pm_company?.name : "",
        filterable: true,
      },
      {
        id: "Keterangan",
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
        Cell: (cell) => {
          return <span>{cell.value.replace(/(<([^>]+)>)/gi, "").substring(0, 20)}...</span>;
        },
      },
      {
        id: "Status",
        Header: "Status",
        accessor: (data) => data?.pm_status?.name ? data?.pm_status?.name : "",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ], [paymentMethodList, userRole, isCheckAll]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = paymentMethodList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setPaymentMethodList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? null);
  }, 300);

  const memoizedData = useMemo(() => paymentMethodList, [paymentMethodList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: paymentMethodList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Tipe", "Urutan", "Status", "Keterangan", "Perusahaan", "Tag"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const [searchTag, setSearchTag] = useState("");

  function handlePaymentMethodStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      branchId: branchSelected?.value,
    };
    dispatch(onGetPaymentMethods(param));
  }

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "NON CASHFLOW", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + " - " + item.name + ", " + item?.budget_branch?.branch_code;
        const id = item.id;
        var obj = { label: name, value: id };
        if (validation?.values?.branch?.value === item.branchId)
          opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? null).localeCompare(b.label ?? null, undefined, { numeric: true, sensitivity: "base" })).reverse() };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets, validation.values.branch]);

  const handleResetFilter = () => {
    setFilterDate(null);
    setPaymentMethodList([]);
    setSearchValue("");
    setSearchTag("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetPaymentMethodState());
    dispatch(onGetPaymentMethods({ companyId: companySelected?.value, branchId: branchSelected?.value }));
  };

  document.title = "Payment Methods | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={paymentMethodList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeletePaymentMethod} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Keuangan" pageTitle="Jenis Transaksi" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createPaymentMethod") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={paymentMethodDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn ms-1 btn-soft-danger" : userRole && userRole.split(",").indexOf("deletePaymentMethod") !== -1 ? "btn ms-1 btn-soft-danger" : "btn ms-1 btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="paymentMethodList">
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA METODE BAYAR
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? null}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <Select
                              name="searchTag"
                              value={searchTag}
                              isClearable
                              placeholder="Filter Tag"
                              onChange={(e) => {
                                setSearchTag(e);
                                if (e.value) {
                                  setSearchValue(e.label);
                                  onChange(e.label);
                                }
                                else {
                                  setSearchValue("NON TAG");
                                  onChange("NON TAG");

                                }
                                gotoPage(0);
                              }}
                              options={tagList}
                            ></Select>

                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Metode Pembayaran" : "Tambah Metode Pembayaran"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                dispatch(setClientSelect(e));
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setCompanySelect(e));
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Proyek / Cabang
                            </Label>
                            <Select
                              name="branch"
                              isClearable
                              placeholder="Pilih Cabang"
                              value={validation.values.branch}
                              onChange={(e) => {
                                validation.setFieldValue("branch", e);
                              }}
                              options={branchList}
                            ></Select>
                            {validation.touched.branch && validation.errors.branch && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.branch}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Metode Pembayaran" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="type-field" className="form-label">
                              Tipe Transaksi
                            </Label>
                            <Select
                              name="type"
                              isClearable
                              placeholder="Pilih Tipe Metode Pembayaran"
                              value={validation.values.type}
                              onChange={(e) => {
                                validation.setFieldValue("type", e);
                              }}
                              options={typeData}
                            ></Select>
                            {validation.touched.type && validation.errors.type && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.type}
                              </small>
                            )}
                          </div>

                          <div className="mb-3">
                            <Label className="form-label">Cashflow</Label>
                            <Select
                              name="cashflow"
                              isClearable
                              value={validation.values.cashflow}
                              placeholder="Pilih Cashflow"
                              onChange={(e) => {
                                validation.setFieldValue("cashflow", e);
                              }}
                              options={budgetList}
                            ></Select>
                            {validation.touched.cashflow && validation.errors.cashflow && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.cashflow}
                              </small>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label className="form-label" htmlFor="account">
                              Akun Debit Metode Pembayaran
                            </label>
                            <Select
                              isClearable
                              name="account"
                              value={validation.values.account}
                              placeholder="Pilih Akun Metode Bayar"
                              onChange={(e) => {
                                validation.setFieldValue("account", e);
                              }}
                              options={accountingList}
                            ></Select>
                            {validation.touched.account && validation.errors.account && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.account}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="account">
                              Akun Kredit Metode Pembayaran
                            </label>
                            <Select
                              isClearable
                              name="accountTo"
                              value={validation.values.accountTo}
                              placeholder="Pilih Akun Lawan Metode Bayar"
                              onChange={(e) => {
                                validation.setFieldValue("accountTo", e);
                              }}
                              options={accountingList}
                            ></Select>
                            {validation.touched.accountTo && validation.errors.accountTo && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.accountTo}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <label className="form-label" htmlFor="account">
                              Tag Keuangan
                            </label>
                            <Select
                              isClearable
                              name="tag"
                              value={validation.values.tag}
                              placeholder="Pilih Tag"
                              onChange={(e) => {
                                validation.setFieldValue("tag", e);
                              }}
                              options={tagList}
                            ></Select>
                            {validation.touched.tag && validation.errors.tag && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.tag}
                              </small>
                            )}
                          </div>
                          <div className="mb-3 d-none">
                            <label className="form-label" htmlFor="account">
                              Akun Terhutang
                            </label>
                            <Select
                              name="accountPayable"
                              value={validation.values.accountPayable}
                              placeholder="Pilih Akun Pengakuan Hutang"
                              onChange={(e) => {
                                validation.setFieldValue("accountPayable", e);
                              }}
                              options={accountingList}
                            ></Select>
                            {validation.touched.accountPayable && validation.errors.accountPayable && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.accountPayable}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="sort_order-field" className="form-label">
                              No Urut
                            </Label>
                            <Input name="sort_order" id="sort_order-field" className="form-control" placeholder="Isi No Urut" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.sort_order} invalid={validation.touched.sort_order && validation.errors.sort_order ? true : false} />
                            {validation.touched.sort_order && validation.errors.sort_order ? <FormFeedback type="invalid">{validation.errors.sort_order}</FormFeedback> : null}
                          </div>
                          <div className="mb-1">
                            <Input name="isCash" id="isCash-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isCash} /> &nbsp;
                            <Label htmlFor="isCash-field" className="form-label">
                              Metode Pembayaran Adalah Kas dan Bank
                            </Label>
                          </div>
                          <div className="mb-1">
                            <Input name="isBooked" id="isBooked-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isBooked} /> &nbsp;
                            <Label htmlFor="isBooked-field" className="form-label">
                              Metode Pembayaran Tanda Jadi (Booking)
                            </Label>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" rows={2} placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? null} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "UPDATE" : "SIMPAN"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PaymentMethod;
